<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll"
          @switchProcessamentosExpirados="processamentosExpirados = $event; getAll()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MontagensAisIncrementaisService from '@/services/MontagensAisIncrementaisService';
import pusherMixins from '@/mixins/pusherMixins';

export default {
  name: 'MontagensAisIncrementaisHistorico',

  components: {
    Tabela: () => import('@/components/montagensAisIncrementais/Tabela.vue')
  },

  mixins: [pusherMixins],

  data() {
    return {
      items: [],
      loading: false,
      processamentosExpirados: false
    };
  },

  mounted() {
    this.getAll();
    this.subscribe();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshMontagensAisIncrementais', () => {
        this.getAll();
      });
    },

    getAll() {
      this.loading = true;

      MontagensAisIncrementaisService.getAll(this.processamentosExpirados)
        .then((response) => {
          this.items = response.data.data || [];
        })
        .catch((error) => {
          this.$toast.error('Erro ao recuperar histórico do Laudo Express.', '', { position: 'topRight' });
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
